import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment.js";
import ModalComponent from "../../../modals/ModalComponent.jsx";
import { MarkAsReadNotificationApi } from "../../../../api/request/notification";
import { CloseOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const Notifications = ({
  notifications,
  getNotification,
  setIsNotification,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [notificationData, setNotificationData] = useState(notifications || []);
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);

  const viewNotification = (notification) => {
    setSelectedNotification(notification);
    markAsRead(notification?.id);
    setIsOpen(true);
  };

  const markAsRead = async (id) => {
    try {
      setIsNotificationLoading(true);
      const params = { notification_id: id };
      const { data } = await MarkAsReadNotificationApi(params);
      if (data?.status) {
        let updatedNotifications = notificationData?.map((item) => {
          if (item?.id === id) {
            return { ...item, is_read: true };
          } else {
            return item;
          }
        });
        setNotificationData(updatedNotifications);
        getNotification();
      }
    } catch (error) {
    } finally {
      setIsNotificationLoading(false);
    }
  };

  useEffect(() => {
    setNotificationData(notifications);
  }, [notifications]);

  const navigateNotification = [
    {
      label: "files",
      path: "/services",
    },
    {
      label: "chat",
      path: "/communication",
    },
    {
      label: "dashboard",
      path: "/dashboard",
    },
    {
      label: "signature",
      path: "/dashboard",
    },
    {
      label: "dashboard",
      path: "/dashboard",
    },
    {
      label: "invoice",
      path: "/dashboard",
    },
  ];

  const handleModalClick = () => {
    if (!selectedNotification?.notify_type) return;

    const matched = navigateNotification?.find(
      (item) => item?.label === selectedNotification?.notify_type
    );

    if (matched) {
      setIsOpen(false);
      setIsNotification(false);
      navigate(matched?.path);
    }
  };

  return (
    <>
      <div>
        {/* Loading State */}
        {isNotificationLoading || isLoading ? (
          <div className="flex justify-center items-center h-screen">
            <Spin size="large" />
          </div>
        ) : notificationData?.length > 0 ? (
          <div>
            {notificationData?.map((item, index) => (
              <div
                className={`relative flex items-center gap-4 border rounded-lg p-5 cursor-pointer my-2 transition-all duration-200 ${
                  item?.is_read ? "bg-white" : "bg-primaryLight"
                }`}
                key={index}
                onClick={() => viewNotification(item)}
              >
                <div className="absolute top-1 right-1 py-0.5 px-1 rounded-full hover:bg-gray-100 transition-colors">
                  <CloseOutlined
                    className="text-gray-400 hover:text-gray-600 text-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      markAsRead(item?.id);
                    }}
                  />
                </div>

                <div className="w-full">
                  <div className="flex justify-between items-center w-full">
                    <p className="sub-title text-base line-clamp-1 w-2/3">
                      {item?.title}
                    </p>
                    <p className="text-sm text-gray-400">
                      {moment(item?.created_at).fromNow()}
                    </p>
                  </div>
                  <p className="mt-1 text-gray-500 line-clamp-1">
                    {item?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-12">
            <p className="text-gray-400 text-center text-lg">No Notification</p>
          </div>
        )}
      </div>

      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Notification"
        width={800}
      >
        <div
          className="flex justify-between items-center w-full !cursor-pointer"
          onClick={() => {
            markAsRead(selectedNotification?.id);
            handleModalClick();
          }}
        >
          <p className="title mb-4">{selectedNotification?.title}</p>
          <p className="text-sm text-gray-400 text-right mb-4 cursor-pointer">
            {" "}
            {moment(selectedNotification?.createdDate).fromNow()}
          </p>
        </div>
        <p className="text-lg cursor-pointer">
          {selectedNotification?.description}
        </p>
      </ModalComponent>
    </>
  );
};

export default Notifications;
